import { ExperienceWidget } from './experience-widget.model';

export class ExperienceWidgetCommand {
    name: string;
    parent: { id: string };

    constructor(tempExperienceWidget: ExperienceWidget) {
        // this.name = tempExperienceWidget.name;
    }
}
